// extracted by mini-css-extract-plugin
export var textInput = "_l8-0";